/** Scoreklassen und Auswahlbedingung (02 „Pre-Heating und Prüfung“, 06 „Ergebnisse“). */

export const SCORE_BUCKETS = [
  { key: '0-9', label: '0–9', min: 0, max: 9 },
  { key: '10-19', label: '10–19', min: 10, max: 19 },
  { key: '20-29', label: '20–29', min: 20, max: 29 },
  { key: '30-39', label: '30–39', min: 30, max: 39 },
  { key: '40-49', label: '40–49', min: 40, max: 49 },
  { key: '50-59', label: '50–59', min: 50, max: 59 },
  { key: '60-69', label: '60–69', min: 60, max: 69 },
  { key: '70-79', label: '70–79', min: 70, max: 79 },
  { key: '80-89', label: '80–89', min: 80, max: 89 },
  { key: '90-100', label: '90–100', min: 90, max: 100 },
] as const;

export const NO_VALID_KEY = 'none';
export const NO_VALID_LABEL = 'Ohne gültige Bewertung';

export function bucketIndex(score: number): number {
  if (!Number.isFinite(score) || score < 0 || score > 100) return -1;
  return Math.min(9, Math.floor(score / 10));
}

export type Distribution = { key: string; label: string; count: number }[];

export type ScoreRow = { correctness: number | null; errorRisk: number | null; scoresCurrent: boolean };

/** Veraltete oder fehlende Scores landen in „Ohne gültige Bewertung“, damit die Summe zur Tabelle passt. */
export function distribution(rows: readonly ScoreRow[], field: 'correctness' | 'errorRisk'): Distribution {
  const counts: number[] = Array.from({ length: SCORE_BUCKETS.length }, () => 0);
  let none = 0;
  for (const r of rows) {
    const v = r[field];
    const idx = r.scoresCurrent && v !== null ? bucketIndex(v) : -1;
    if (idx < 0) none++;
    else counts[idx] = (counts[idx] ?? 0) + 1;
  }
  return [
    ...SCORE_BUCKETS.map((b, i) => ({ key: b.key, label: b.label, count: counts[i] ?? 0 })),
    { key: NO_VALID_KEY, label: NO_VALID_LABEL, count: none },
  ];
}

/** Inklusive Schwellen: richtigkeit >= minimum && fehlerrisiko <= maximum. */
export function meetsThresholds(correctness: number | null, errorRisk: number | null, minCorrectness: number, maxErrorRisk: number): boolean {
  if (correctness === null || errorRisk === null) return false;
  return correctness >= minCorrectness && errorRisk <= maxErrorRisk;
}

export function clampScore(v: number): number {
  if (!Number.isFinite(v)) return 0;
  return Math.max(0, Math.min(100, Math.round(v)));
}

export function startButtonLabel(count: number): string {
  return `Start: ${count.toLocaleString('de-DE')} ${count === 1 ? 'Ticket' : 'Tickets'} beantworten und lösen`;
}
